import { render } from "./CurrentRestaurantMenu.vue?vue&type=template&id=65da1626&scoped=true"
import script from "./CurrentRestaurantMenu.vue?vue&type=script&lang=js"
export * from "./CurrentRestaurantMenu.vue?vue&type=script&lang=js"

import "./CurrentRestaurantMenu.vue?vue&type=style&index=0&id=65da1626&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65da1626"]])

export default __exports__